import {
  fetchVetAttributes,
  fetchPracticeAttributes,
} from '../api/vet_practice_attributes';
import { fetchHorseAttributes } from '../api/horses';

function checkSessionStorageForAttribute(objectType, attribute) {
  const storageName = `${objectType}_${attribute}`;
  return JSON.parse(sessionStorage.getItem(storageName));
}

function storeAttribute(storageName, attribute) {
  sessionStorage.setItem(storageName, JSON.stringify(attribute));
}

function vetAttributeList(attribute) {
  const localAttr = checkSessionStorageForAttribute('vet', attribute);
  if (localAttr) {
    return new Promise((resolve) => resolve(localAttr));
  }
  return fetchVetAttributes({ attribute }).then((data) => {
    storeAttribute(`vet_${attribute}`, data);
    return new Promise((resolve) => resolve(data));
  });
}

const practiceAttributeList = (attribute) => {
  const localAttr = checkSessionStorageForAttribute('practice', attribute);
  if (localAttr) {
    return new Promise((resolve) => resolve(localAttr));
  }
  return fetchPracticeAttributes({ attribute }).then((data) => {
    storeAttribute(`practice_${attribute}`, data);
    return new Promise((resolve) => resolve(data));
  });
};

const horseAttributeList = (attribute) => {
  const localAttr = checkSessionStorageForAttribute('horse', attribute);
  if (localAttr) {
    return new Promise((resolve) => resolve(localAttr));
  }
  return fetchHorseAttributes({ attribute }).then((data) => {
    storeAttribute(`horse_${attribute}`, data);
    return new Promise((resolve) => resolve(data));
  });
};

export const objectAttribute = ({ objectType, attribute }) => {
  switch (objectType) {
    case 'vet':
      return vetAttributeList(attribute);
    case 'practice':
      return practiceAttributeList(attribute);
    case 'horse':
      return horseAttributeList(attribute);
    default:
      break;
  }

  return [];
};
